import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import "./applyleave.css";
import { baseUrl } from "../../../services/config";
import { DatePicker, Divider, Space } from "antd";
import Drawer from "@material-ui/core/Drawer";
import { useLocation } from "react-router-dom";
import moment from "moment";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { CardContent } from "@material-ui/core";
const { RangePicker } = DatePicker;

const ApplyLeave = () => {
  let location = useLocation();
  const myUser = location.state;
  const authtoken = localStorage.getItem("userToken");

  const [list, setList] = useState([]);
  const [leaveType, setLeaveType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [note, setNote] = useState("");

  const [fromDate, setFromDate] = useState(null);
  const [fromDateObj, setFromDateObj] = useState(new Date());
  const [toDate, settoDate] = useState(null);
  const [toDateObj, settoDateObj] = useState(new Date());
  const [leaveDuration, setLeaveDuration] = useState([]);
  const [leaveDurationList, setLeaveDurationList] = useState([]);
  const [workPatternDataObject, setWorkPatternDataObject] = useState({});
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const queryParams = new URLSearchParams(location.search);
  const isEdit = queryParams.get("isEdit") === "true";
  const [currentUserLeaves, setCurrentUserLeaves] = useState([]);
  const [drawerModal, setdrawerModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});

  console.log("myUser", myUser);
  const history = useHistory();

  const goBack = () => {
    history.push(myUser?.navigationRoute || '/users');
  };
useEffect(() => {
 getLeaveDetails(myUser);
}, [])

  useEffect(() => {
    getHoliDaysTypes();
  }, [getHoliDaysTypes]);
  useEffect(() => {
        if (isEdit && myUser?.leaveObj && list.length > 0) {
            populateEditFields();
        }
    }, [isEdit, list, myUser?.leaveObj, populateEditFields])

    const populateEditFields = () => {
        const leaveObj = myUser?.leaveObj;
        if (!leaveObj) return;

        // Set leave type
        setLeaveType(leaveObj.type.id.toString());
        
        // Set note
        setNote(leaveObj.note || "");
        
        // Convert dates from DD/MM/YY to YYYY-MM-DD format
        const startDateFormatted = moment(leaveObj.start_date, 'DD/MM/YY').format('YYYY-MM-DD');
    const endDateFormatted = moment(leaveObj.end_date, 'DD/MM/YY').format('YYYY-MM-DD');
    
    setStartDate(startDateFormatted);
    setEndDate(endDateFormatted);
        
        // Set leave duration from existing leaves data
        const existingLeaves = leaveObj.leaves.map(leave => ({
            day: leave.day,
            duration: leave.duration === 'FULL_DAY' ? '3' : leave.duration === 'FIRST_HALF' ? '1' : '2',
            working_day: leave.working_day
        }));
        
        setLeaveDuration(existingLeaves);
        setCount(existingLeaves.filter(leave => leave.working_day === 1).length);
        
        console.log('Edit mode initialized with:', {
            leaveType: leaveObj.type.id,
            startDate: startDateFormatted,
            endDate: endDateFormatted,
            note: leaveObj.note,
            leaveDuration: existingLeaves
        });
    };

  const getHoliDaysTypes = () => {
    fetch(`${baseUrl}/mgmt/leave-types`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          if (data.payload) {
            setList(data.payload);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
    const getLeaveDetails = (user) => {
    setSelectedUser(user);
      // const found = usersList.find(item => item.first_name == user.first_name && item.last_name == user.last_name)
      fetch(`${baseUrl}/mgmt/users/${user.id}/leave-applications`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.metadata.success) {
            setCurrentUserLeaves(data.payload);
          }
        })
        .catch((err) => {
          console.log(err);
        });
  };

  function calculateWorkingDays(
    startDateStr,
    endDateStr,
    workPattern,
    leavePattern
  ) {
    console.log(workPattern, "here goooooo");
    console.log(leavePattern, "here goooooo");
    const startDate = moment(startDateStr);
    const endDate = moment(endDateStr);
    const workingDaysArray = [];

    let currentDate = startDate.clone();
    while (currentDate.isSameOrBefore(endDate, "day")) {
      const dayName = currentDate.format("dddd").toLowerCase();
      const workingDayValue =
        workPattern[dayName] && leavePattern[dayName] ? 1 : 0;
      workingDaysArray.push({
        day: currentDate.format("YYYY-MM-DD"),
        duration: "3",
        working_day: workingDayValue,
      });
      currentDate.add(1, "day");
    }

    return workingDaysArray;
  }

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    // Calculate leave duration based on working days
    const leaveDuration = calculateWorkingDays(
      start,
      end,
      myUser.work_pattern,
      myUser.leave_pattern
    );
    console.log(leaveDuration, "hgdshfgsafgsajhf");
    console.log(leaveDuration, "this is the resultant");
    const filteredData = leaveDuration.filter((lev) => lev.working_day == "1");
    console.log(filteredData, "ffabsha");
    setCount(filteredData.length);
    setLeaveDuration(filteredData);
  };

  const handleApplyLeave = () => {
    if (leaveDuration.length == 0) {
      return;
    }
    if (leaveType == "") {
      return toast.error("Please select the Leave Type");
    }
    if (startDate == "" && endDate == "") {
      return toast.error("Please select the start and end date");
    }
    if (note == "") {
      return toast.error("Please enter note");
    }
    setLoading(true);
    fetch(isEdit ? `${baseUrl}/mgmt/apply-user/${myUser.id}/update-leave/${myUser?.leaveObj?.id}?_method=PUT` : `${baseUrl}/mgmt/apply-user/${myUser.id}/leave-application`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authtoken,
      },
      body: JSON.stringify({
        leave_type_id: leaveType,
        start_date: moment(startDate).format("YYYY-MM-DD"),
        end_date: moment(endDate).format("YYYY-MM-DD"),
        leaves: leaveDuration,
        // working_day: true,
        note: note,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.metadata.success) {
          toast.success(data.metadata.message);
          goBack();
        } else if (!data.metadata.success) {
          if (toString.call(data.metadata.message) == "[object Object]") {
            const errorMessageArray = Object.values(
              data.metadata.message
            ).flatMap((messages) => messages);
            errorMessageArray.forEach((message) => toast.error(message));
          } else if (toString.call(data.metadata.message) == "[object Array]") {
            Object.values(data.metadata.message).map((msg) => {
              toast.error(msg);
            });
          } else {
            if (data.metadata.message != "") {
              toast.error(data.metadata.message);
            }
          }
        } else {
          toast.error(`Something went wrong`);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Something went wrong!");
      });
  };

  const duration = [
    { label: "Full Day", id: "3" },
    { label: "First Half", id: "1" },
    { label: "Second Half", id: "2" },
  ];
  const disabledDate = (current) => {
    // Can not select days before today and today
    return (
      current &&
      current <
        moment()
          .subtract(1, "days")
          .endOf("day")
    );
  };
  console.log(leaveDuration.length, "here is the length");
  console.log(leaveDuration, "here is the length");
    const givingWorkingDays = (array) => {
    const response = array.filter((item) => item.working_day == 1);
    if (response.length == 0 || response.length == 1) {
      return response.length + " Day";
    } else {
      return response.length + " Days";
    }
  };
  return (
    <>
      <Card>
        <CardHeader title="Apply">
          <CardHeaderToolbar></CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="container">
            {myUser && (
              <div className="row mb-4">
                <div className="col-md-12">
                  <Card>
                    <CardHeader title="Employee Details">
                      <CardHeaderToolbar>
                        <button
                        onClick={() => setdrawerModal(true)}
                        className="btn btn-primary"
                      >
                        All Leave Details
                      </button>
                      </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>
                      <div className="row">
                        <div className="col-md-2">
                          <img
                            src={myUser?.image?.url || "/media/users/blank.png"}
                            alt="Profile"
                            className="img-fluid rounded-circle"
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div className="col-md-10" style={{marginTop: "10px"}}>
                          <div className="row">
                            <div className="col-md-3">
                              <strong>Name:</strong>
                              <p>
                                {myUser?.first_name} {myUser?.last_name}
                              </p>
                            </div>

                            <div className="col-md-3">
                              <strong>Username:</strong>
                              <p>{myUser?.username}</p>
                            </div>
                            <div className="col-md-3">
                              <strong>Email:</strong>
                              <p>{myUser?.email}</p>
                            </div>
                                 <div className="col-md-3">
                              <strong>Role:</strong>
                              <p>
                                {myUser?.role[0]?.name}
                              </p>
                            </div>
                          </div>
                       
                 
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}

            <Divider />
            <div className="row">
              <div className="col-md-4">
                <label>
                  <b>Select Leave Type</b>
                </label>
                <select
                value={leaveType}
                  onChange={(e) => setLeaveType(e.target.value)}
                  className="form-control"
                  style={{ height: 40 }}
                  aria-label="Default select example"
                >
                  <option selected value="">
                    Select..
                  </option>
                  {list.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <div>
                  <label>
                    <b>Select Start and End Date</b>
                  </label>
                </div>
                {/* <RangePicker 
                                // disabledDate={disabledDate}
                                 onChange={(e, value) => {
                                    console.log("ffff", value); //  ['2024-02-16', '2024-02-19']
                                    handleDateChange(value)
                                }} style={{ width: "100%", height: "40px" }} /> */}
                {/* <RangePicker
                  format="DD/MM/YYYY"
                  onChange={(dates, dateStrings) => {
                    // Convert the date objects to yyyy-mm-dd format
                    const formattedDates = dates
                      ? dates.map((date) => date.format("YYYY-MM-DD"))
                      : [];
                    console.log("ffff", formattedDates); 
                    handleDateChange(formattedDates);
                  }}
                  style={{ width: "100%", height: "40px" }}
                /> */}
                <RangePicker
  value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
  format="DD/MM/YYYY"
  onChange={(dates, dateStrings) => {
    // Convert the date objects to yyyy-mm-dd format
    const formattedDates = dates
      ? dates.map((date) => date.format("YYYY-MM-DD"))
      : [];
    console.log("ffff", formattedDates); // Will show ['2025-06-19', '2025-06-21']
    handleDateChange(formattedDates);
  }}
  style={{ width: "100%", height: "40px" }}
/>
              </div>
              <div className="col-md-3">
                <div className="btn btn-primary mt-9" style={{ width: "100%" }}>
                  Total Working Day Leaves {count}{" "}
                </div>
              </div>
              <div className="col-md-12 mt-2">
                <label>
                  <b>Add Note</b>
                </label>
                <textarea
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  className="form-control"
                  placeholder="Add Note"
                  style={{ height: "100px", width: "100%" }}
                ></textarea>
              </div>
              <Divider />
              {leaveDuration.map(
                (lev, index) =>
                  lev.working_day == "1" && (
                    <div className="col-md-4 mt-3">
                      <div className="leaves-cards">
                        <div>
                          <b>Leave Date</b>
                          <p className="mt-2">
                            {moment(lev.day, "YYYY-MM-DD").format("DD/MM/YYYY")}
                          </p>
                        </div>
                        <div>
                          <b>Single Day Options</b>
                          <select
                            onChange={(e) => {
                              leaveDuration[index].duration = e.target.value;
                              setLeaveDuration([...leaveDuration]);
                            }}
                            className="form-control"
                            style={{ height: 40 }}
                            aria-label="Default select example"
                            value={lev.duration}
                          >
                            {duration.map((item) => (
                              <option value={item.id}>{item.label}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className="submit-button-leaver">
              <button className="btn btn-secondary" onClick={goBack}>
                Cancel
              </button>
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100px",
                  }}
                >
                  <Spinner variant="dark" animation="border" />
                </div>
              ) : (
                <button
                  disabled={leaveDuration.length == 0 ? true : false}
                  onClick={() => handleApplyLeave()}
                  className="btn btn-primary mx-2"
                >
                {isEdit ? "Update" : "Submit"}
                </button>
              )}
            </div>
          </div>
        </CardBody>
         <Drawer
                anchor={"right"}
                open={drawerModal}
                onClose={() => setdrawerModal(false)}
              >
                <div style={{ width: "400px" }}>
                  <button
                    onClick={() =>
                      history.push(`/view-holiday/${selectedUser.id}`, selectedUser)
                    }
                    className="btn btn-primary"
                  >
                    See More
                  </button>
                  <div
                    className="row"
                    style={{ justifyContent: "flex-end", margin: 10 }}
                  >
                    {/* NOw we will check if item is already exits in array then show box otherwise show date */}
                    <div
                      onClick={() => setdrawerModal(false)}
                      className="offcanvas-close mt-n1 pr-5"
                    >
                      <a
                        className="btn btn-xs btn-icon btn-light btn-hover-primary"
                        id="kt_quick_panel_close"
                      >
                        <i className="ki ki-close icon-xs text-muted"></i>
                      </a>
                    </div>
                  </div>
        
                  <div className="mt-5 text-center">
                    <span className="font-weight-bolder">Leave Details</span>
                  </div>
                  {currentUserLeaves &&
                    currentUserLeaves.map((leav) => (
                      <>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <Card className="allholiCard" variant="outlined">
                            <CardContent
                              style={{
                                paddingTop: "0px",
                                paddingLeft: "15px",
                                paddingBottom: "5px",
                                paddingRight: "0px",
                              }}
                              className="text-center"
                            >
                              <div className="">
                                <div className="row">
                                  <div className="col-md-8 text-left pt-2">
                                    <p>
                                      {/* Duration: */}
                                      <b>
                                        {givingWorkingDays(leav.leaves)}
                                        {/* {getNumberofdays(
                                          leav.start_date,
                                          leav.end_date
                                        )}{" "}
                                        {getNumberofdays(
                                          leav)} */}
                                        {/* {getNumberofdays(
                                          leav.start_date,
                                          leav.end_date
                                        ) == 1
                                          ? "day"
                                          : "days"} */}
                                      </b>
                                      {/* &nbsp; {leav.start_date} to {leav.end_date} */}
                                      <p>
                                        {leav.start_date} to {leav.end_date}
                                      </p>
                                    </p>
                                    <p style={{ marginBottom: "0" }}>
                                      {leav?.type?.name}
                                    </p>
                                  </div>
        
                                  <div className="col-md-4 text-center">
                                    <p
                                      className={
                                        leav?.status == "PENDING"
                                          ? "bg-warning"
                                          : leav?.status == "REJECTED"
                                          ? "bg-danger"
                                          : "bg-primary"
                                      }
                                      style={{ marginBottom: "0", color: "white" }}
                                    >
                                      {leav?.status}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </CardContent>
                          </Card>
                        </div>
                        {/* <div className="row p-4">
                          <div className="col-md-6">
                            <label><strong>Name: {' '}</strong></label>
        
                          </div>
                          <div className="col-md-6">
                            <span>{leav?.type?.name}</span>
                          </div>
                        </div> */}
                        {/* <div className="row p-4">
                          <div className="col-md-6">
                            <label><strong>Status: {' '}</strong></label>
        
                          </div>
                          <div className="col-md-6">
                            <span>{leav?.status}</span>
                          </div>
                        </div> */}
                        {/* <hr /> */}
                      </>
                    ))}
                </div>
              </Drawer>
      </Card>
    </>
  );
};

export default ApplyLeave;
